// extracted by mini-css-extract-plugin
module.exports = {"nameWidth":"45%","brandWidth":"15%","dateWidth":"15%","tagsWidth":"20%"};